( function ( $ ) {

	// The confirmation replaces the form markup, so the banner loses the height the
	// form was giving it. Flag the section to restore some breathing room below.
	function refresh_submitted_state () {
		$( 'section.form_banner' ).each( function () {
			$( this ).toggleClass( 'is-form-submitted', !! $( '.gform_confirmation_wrapper', this ).length );
		});
	}

	$( document ).on( 'gform_confirmation_loaded', refresh_submitted_state );

	$( refresh_submitted_state );

})( jQuery );
